export const BuildVersion = {
    Version: 'main',
    Build: '79e2d289',
    Branch: 'develop'
};